import { render, staticRenderFns } from "./Invoices-Single.vue?vue&type=template&id=07c0ce36&"
import script from "./Invoices-Single.vue?vue&type=script&lang=js&"
export * from "./Invoices-Single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports